import React from "react";
import Component from "react-pure-render/component";
import { findDOMNode } from "react-dom";
import MenuItem from "./menuItem.react";
import { DragSource, DropTarget } from "react-dnd";
import DragLayer from "../components/dragLayer.react";
import DragAndDrop from "../components/dragAndDrop.react";
import { addNotificationsForInvalidFields } from "../lib/validationWeb";

export default class MenuItemDragAndDrop extends Component {
  constructor() {
    super();
  }

  dropAction = () => {
    const {
      draggingItemUID,
      hoveringItemUID,
      menuItems,
      menusTranslations
    } = this.props;
    const self = this;
    const dataObject = menusTranslations.getIn([
      menuItems.getIn([draggingItemUID, "menuTranslationUID"]),
      "dataObject"
    ]);
    dataObject.map(function(item, index) {
      if (item.uid === draggingItemUID) {
        if (index === dataObject.length - 1) {
          let data = item;
          data.beforeUID = null;
          self.updateMenuItem(data, data.uid);
        } else {
          let data = item;
          data.beforeUID = dataObject[index + 1].uid;
          self.updateMenuItem(data, data.uid);
        }
      }
    });
  };

  updateMenuItem = (data, uid) => {
    const { actions, notificationSystem, updateAction } = this.props;
    actions.updateMenuItem(data, uid).then(({ error, payload }) => {
      if (error) {
        addNotificationsForInvalidFields(payload, notificationSystem);
      } else {
        updateAction();
      }
    });
  };

  render() {
    const {
      uid,
      draggingItemUID,
      hoveringItemUID,
      form,
      menuItems,
      menuItemUID,
      actions,
      isRemoveModalVisible,
      isEditModalVisible,
      isAddModalVisible,
      isAddPlaceholdersVisible,
      notificationSystem,
      pages,
      defaultLocale,
      menusTranslations,
      updateAction
    } = this.props;

    return (
      <DragAndDrop
        types="menuItem"
        itemUID={menuItemUID}
        setDraggingItemUID={actions.setDraggingItemUID}
        moveAction={actions.moveMenuItem}
        moveActionProps={{ uid: uid }}
        draggingItemUID={draggingItemUID}
        hoveringItemUID={hoveringItemUID}
        setHoveringItemUID={actions.setHoveringItemUID}
        dropAction={this.dropAction}
      >
        <MenuItem
          form={form}
          menuItems={menuItems}
          menuItemUID={menuItemUID}
          actions={actions}
          uid={uid}
          isRemoveModalVisible={isRemoveModalVisible}
          isEditModalVisible={isEditModalVisible}
          isAddModalVisible={isAddModalVisible}
          isAddPlaceholdersVisible={isAddPlaceholdersVisible}
          notificationSystem={notificationSystem}
          pages={pages}
          defaultLocale={defaultLocale}
          menusTranslations={menusTranslations}
          updateAction={updateAction}
        />
      </DragAndDrop>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/menu/menuItemDragAndDrop.react.js